import { updateKRConst } from '../constants/updateKR.constants';
const initialState = {
	
};

const UpdateKRPopupReducer = (state = initialState, action) => {
	switch (action.type) {
		case updateKRConst.INITIAL_UPDATE_KR_PROPS:
			return {
				...state,
				...action.updateKRData
			}
		case updateKRConst.UPDATE_CONFIDENCE:
			return {
				...state,
				metric: { ...state.metric, confidence: action.data }
			}
		case updateKRConst.UPDATE_METRIC_CONFIDENCE:
			return {...state,
				metric: { ...state.metric, confidence: action.data }
			};
		default:
			return state;
	}
}

export default UpdateKRPopupReducer;